import classNames from 'classnames';
import { m } from 'framer-motion';
import { useState } from 'react';
import HubspotFormItem from '@/components/modules/hubspot-form/hubspot-form-item/hubspot-form-item';
import TabMenu from '@/components/organisms/tab-menu/tab-menu';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './hubspot-form-multi.module.scss';

export interface HubspotFormMultiProps {
  /** Forms to show */
  forms: Content.Components['HubspotFormDto'][];
  /** Indicates whether to show the form in a lightbox */
  isLightbox?: boolean;
  /** The variant of the component to use */
  variant?: Content.Components['ModuleVariant'];
}

const HubspotFormMulti = ({
  forms = [],
  isLightbox = false,
  variant,
}: HubspotFormMultiProps) => {
  const { t } = useI18n();
  const [activeFormId, setActiveFormId] = useState(forms[0].id);

  return (
    <div
      className={classNames(styles.component, {
        [styles.isSurface]: variant === 'surface',
      })}
    >
      <div
        className={classNames({
          [styles.tabs]: !isLightbox,
        })}
      >
        <TabMenu
          activeItem={{
            type: 'id',
            value: activeFormId,
          }}
          className={styles.menu}
          tabs={forms.map(form => ({
            id: form.id,
            onClick: () => {
              setActiveFormId(form.id);
            },
            text:
              form.tabHeadline || form.headline || t('items.common.words.form'),
          }))}
        />
      </div>

      {forms.map(form => (
        <m.div
          key={form.id}
          animate={{ opacity: form.id === activeFormId ? 1 : 0 }}
          initial={false}
          style={{
            display: form.id === activeFormId ? 'block' : 'none',
          }}
          transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
          <HubspotFormItem
            form={form}
            isLightbox={isLightbox}
            isTabbedView={true}
            variant={variant}
          />
        </m.div>
      ))}
    </div>
  );
};

HubspotFormMulti.displayName = 'HubspotFormMulti';

export default HubspotFormMulti;
